import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import styles from "./requestCompleteNotice.module.scss";
import Image from "../../assets/img/selena-a.webp";
import BackBar from "../nav/BackBar";
import { smoothScrollToElement } from "../../utils/GeneralUtils";

type Props = {
  backBarText?: string;
  title: string;
  text: string;
  handler: () => void;
  sub_text?: string;
  displayImage?: boolean;
  img?: string;
};
const RequestCompleteNotice: React.FC<Props> = ({
  backBarText,
  title,
  text,
  sub_text,
  handler,
  displayImage = true,
  img,
}) => {
  useEffect(() => {
    const element = document.getElementById("requestCompleteModal");

    if (element) {
      smoothScrollToElement(element);
    }
  }, []);

  return (
    <div id="requestCompleteModal">
      {backBarText !== undefined ? (
        <BackBar title={backBarText} editable={false} handleClose={handler} />
      ) : null}
      <div className={styles["requestCompleteModal"]}>
        <div className={styles["requestCompleteModal__topSVG"]}>
          <FontAwesomeIcon icon={["fal", "check-circle"]} />
        </div>
        <div className={styles["requestCompleteModal__textBox"]}>
          <h1 className={styles["requestCompleteModal__textBox__title"]}>
            {title}
          </h1>
          <div className={styles["requestCompleteModal__textBox__text"]}>
            {text}
          </div>
          <div className={styles["requestCompleteModal__textBox__sub-text"]}>
            {sub_text}
          </div>
        </div>
        {displayImage === true ? (
          <>
            <div className={styles["requestCompleteModal__img"]}>
              <img src={img ? img : Image} />
            </div>
            <div className={styles["requestCompleteModal__btn"]}>
              <button onClick={handler} type="button">
                完了
              </button>
            </div>
          </>
        ) : (
          <div
            className={`${styles["requestCompleteModal__btn"]} ${styles["noImage"]}`}
          >
            <button onClick={handler} type="button">
              完了
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestCompleteNotice;
